<style type="text/css" media="screen">

.filter-active{
	color: #1DC895 !important;
}

.custome-checkbox .v-input__slot{
	margin: 0px !important;
}

.filter-dialog{
	height:550px !important;
	border-radius: 20px;
}
.scrolable-box{
	min-height: 380px;
	max-height: 380px;
	overflow-y:scroll;
}
.v-dialog--active{
	overflow-x: hidden !important;
}

.custome-date-picker .v-input{
	font-size: 13px !important;  
}

.date-filter{
	width: max-content;
}
.date-filter .v-input__slot .v-input__append-inner{
	margin-top: 4px !important; 
}
.date-filter .v-input__slot{
	padding: 0px 0px 0px 10px !important;
	min-height:33px !important;
}

.day-width,
.month-width{
	width: 60px
}
.year-width{
	width: 80px
}

</style>

<template>
	<div class="shipment-filter">
		<v-dialog
		v-model="$store.state.wallet_filter_dialog"
		width="565"
		class="filter-dialog"
		:scollable="false"
		>
		<v-card  >
			<v-card-text class="pa-0">
				<v-row>
					<v-col md="12" class="border-b" >
						<p class="text-right pr-3" style="margin-bottom:-10px !important">
							<v-icon color="#8F8F8F" small
							@click="$store.dispatch('setWalletFilterDialog', false)">
							mdi-window-close
						</v-icon>
					</p>
					<p class="page-title text-center">{{$lang.FILTER_WALLET.toUpperCase()}}</p>
				</v-col>
			</v-row>
			<v-row class="border-b px-4">
				<v-col md="4" class="border-r pl-4">
					<p class="filter-sub-title">{{$lang.FILTER_USING}}</p>

					<div v-for="(item,i) in filter_option" :key="i" class="py-1 my-1 cursor-pointer" @click="step=(i+1)">
						<span class="filter-options" :class="step==(i+1)?'filter-active':''" v-if="item" >{{item}}</span>
					</div>

				</v-col>
				<!--  filter section -->
				<v-col md="8" class="border-r px-0 scrolable-box" >
					<v-stepper v-model="step" class="elevation-0">
						<v-stepper-items>
							<!-- $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$ -->
							<!-- $$$$$$$$$$$$$$ DATE FILTER $$$$$$$$$$$$$-->
							<!-- $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$ -->

							<v-stepper-content step="1" class="px-5 ">

								<div class="date-filter">
									<!-- from date  -->
									<div>
										<p class="filter-sub-title">{{$lang.FROM}}</p>
										<v-menu bottom  origin="center center" transition="scale-transition">
											<template v-slot:activator="{ on, attrs }">
												<div class="d-flex flex-row elevation-0 custome-date-picker" v-bind="attrs" v-on="on">
													<v-card class="px-1 elevation-0">
														<p class="sub-title-text-dark pb-1">{{$lang.DAY}}</p>
														<v-text-field
														v-model="filter_form_day"
														placeholder="DD"
														outlined
														dense
														single-line
														maxlength="2"
														readonly
														append-icon="mdi-menu-down"
														class="day-width"
														></v-text-field>
													</v-card>
													<v-card class="px-1 elevation-0">
														<p class="sub-title-text-dark pb-1">{{$lang.MONTH}}</p>
														<v-text-field
														v-model="filter_form_month"
														placeholder="MM"
														outlined
														dense
														single-line
														readonly
														append-icon="mdi-menu-down"
														class="month-width"
														></v-text-field>
													</v-card>
													<v-card class="px-1 elevation-0">
														<p class="sub-title-text-dark pb-1">{{$lang.YEAR}}</p>
														<v-text-field
														v-model="filter_form_year"
														placeholder="YYYY"
														outlined
														dense
														single-line
														append-icon="mdi-menu-down"
														class="year-width"
														></v-text-field>
													</v-card>
												</div>
											</template>
											<v-date-picker v-model="form_date" :max="today" @change="dateCahngeHandler()" style="z-index:5">
											</v-date-picker>
										</v-menu>
									</div>
									<!--  To date -->
									<div>
										<p class="filter-sub-title">{{$lang.TO}}</p>
										<v-menu bottom origin="center center" transition="scale-transition">
											<template v-slot:activator="{ on, attrs }">
												<div class="d-flex flex-row elevation-0 custome-date-picker" v-bind="attrs" v-on="on">
													<v-card class="px-1 elevation-0">
														<p class="sub-title-text-dark pb-1">{{$lang.DAY}}</p>
														<v-text-field
														v-model="filter_to_day"
														placeholder="DD"
														outlined
														dense
														single-line
														maxlength="2"
														readonly
														append-icon="mdi-menu-down"
														class="day-width"
														></v-text-field>
													</v-card>
													<v-card class="px-1 elevation-0">
														<p class="sub-title-text-dark pb-1">{{$lang.MONTH}}</p>
														<v-text-field
														v-model="filter_to_month"
														placeholder="MM"
														outlined
														dense
														single-line
														readonly
														append-icon="mdi-menu-down"
														class="month-width"
														></v-text-field>
													</v-card>
													<v-card class="px-1 elevation-0">
														<p class="sub-title-text-dark pb-1">{{$lang.YEAR}}</p>
														<v-text-field
														v-model="filter_to_year"
														placeholder="YYYY"
														outlined
														dense
														single-line
														append-icon="mdi-menu-down"
														class="year-width"
														></v-text-field>
													</v-card>
												</div>
											</template>
											<v-date-picker v-model="to_date" :min="form_date" :max="today" @change="dateCahngeHandler()">
											</v-date-picker>
										</v-menu>
									</div>
								</div>

							</v-stepper-content>
						</v-stepper-items>
					</v-stepper>
				</v-col>

			</v-row>
		</v-card-text>

		<v-card-actions>
			<v-row >
				<v-col md="6" >
					<p class="sub-title-text-dark">
						{{$lang.FILTER_SELECTED}}: {{filter_count}}
					</p>
				</v-col>
				<v-col md="6" class="text-right">
					<v-btn text color="primary" @click="clearFIlter"  class="mr-3"> 
						<span class="messge-text-green fs-13 underline">
							{{$lang.CLEAR_ALL}}
						</span>
					</v-btn> 
					<v-btn color="primary" @click="applyFilter" width="90">
						<span class="fs-13 font-bold px-4 "> {{$lang.APPLY}}  </span>
					</v-btn> 
				</v-col>

			</v-row>
		</v-card-actions>
	</v-card>
</v-dialog>
</div>
</template>


<script>
export default {
	components: {
    // DateDropdown,
},
props:['filter_data'],
data () {
	return {
		step:1,
		dialog: true,
		filter_option:['Date'],
		// 'Wholesaler','Reciver',
		today:new Date().toISOString().substr(0, 10),
		form_date:new Date().toISOString().substr(0, 10),
		to_date:new Date().toISOString().substr(0, 10),

		filter_form_day:null,
		filter_form_month:null,
		filter_form_year:null,
		filter_to_day:null,
		filter_to_month:null,
		filter_to_year:null,

		wholesaler_serch_query:"",
		Wholesaler_list:[],

		retailer_serch_query:"",
		retailer_list:[],
		filter_count:0,

	}
},
created(){
	// this.getReceverList()
	this.setDisplayDate()
},

methods:{
	manageCount(){
		// let r_len=this.filter_data.retailer_id_list.length
		let d_len=0;
		if (this.filter_data.filter_date_from)
			d_len=1


		this.filter_count=(d_len)
	},
	applyFilter(){
		this.filter_data.filter_count=this.filter_count
		this.$emit('filter')
		this.$store.dispatch('setWalletFilterDialog', false)
	},

	clearFIlter(){
		// this.filter_data.retailer_id_list=[]
		this.filter_data.filter_date_from=""
		this.filter_data.filter_date_to=""
		this.manageCount()
	},
	dateCahngeHandler(){
		this.filter_data.filter_date_from=this.form_date
		this.filter_data.filter_date_to=this.to_date
		this.setDisplayDate()
		this.manageCount()
	},
	setDisplayDate(){
		console.log(this.form_date)
		let from_date_arr=this.form_date.toString().split('-')
		this.filter_form_day=from_date_arr[2]
		this.filter_form_month=from_date_arr[1]
		this.filter_form_year=from_date_arr[0]

		let to_date_arr=this.to_date.toString().split('-')
		this.filter_to_day=to_date_arr[2]
		this.filter_to_month=to_date_arr[1]
		this.filter_to_year=to_date_arr[0]
	}



},
}
</script>